import './styles';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {Box} from '@mui/material';

import {PaymentLinkLogo} from '@/app/main/paymentLink/components/PaymentLinkLogo/PaymentLinkLogo';

import {SplitsInvitationCard} from './components/SplitsInvitationCard';
import {SplitsLandingPromoCard} from './components/SplitsLandingPromoCard';
import {SplitsOtpCard} from './components/SplitsOtpCard';
import {SplitsPhoneCard} from './components/SplitsPhoneCard';
import {SplitsSelectMemberCard} from './components/SplitsSelectMemberCard';
import {SPLITS_VIEW_STEP} from './constants';
import {
  SplitsViewModelProvider,
  useSplitBillsViewModelProvider,
} from './SplitsViewModelContext';

function SplitsLandingContent() {
  const {
    step,
    inviterName,
    isLoadingSplitData,
    onGetAvatarImage,
    phone,
    setPhone,
    formattedPhone,
    isPhoneValid,
    otp,
    setOtp,
    resendSeconds,
    canResend,
    onContinueFromLanding,
    onSubmitPhone,
    onResendOtp,
    onSubmitOtp,
    onOpenAccount,
    canGoBack,
    handleBack,
    selectableParticipants,
    selectedParticipant,
    onSelectParticipant,
    onContinueFromSelectParticipant,
  } = useSplitBillsViewModelProvider();

  const renderStepCard = () => {
    switch (step) {
      case SPLITS_VIEW_STEP.LANDING:
        return (
          <SplitsInvitationCard
            inviterName={inviterName}
            isLoadingSplitData={isLoadingSplitData}
            onContinueFromLanding={onContinueFromLanding}
            onGetAvatarImage={onGetAvatarImage}
          />
        );
      case SPLITS_VIEW_STEP.SELECT_MEMBER:
        return (
          <SplitsSelectMemberCard
            participants={selectableParticipants}
            selectedParticipant={selectedParticipant}
            onSelectParticipant={onSelectParticipant}
            onContinueFromSelectParticipant={onContinueFromSelectParticipant}
            onGetAvatarImage={onGetAvatarImage}
          />
        );
      case SPLITS_VIEW_STEP.PHONE_INPUT:
        return (
          <SplitsPhoneCard
            phone={phone}
            setPhone={setPhone}
            isPhoneValid={isPhoneValid}
            onSubmitPhone={onSubmitPhone}
            onGetAvatarImage={onGetAvatarImage}
          />
        );
      case SPLITS_VIEW_STEP.OTP:
      default:
        return (
          <SplitsOtpCard
            formattedPhone={formattedPhone}
            otp={otp}
            setOtp={setOtp}
            canResend={canResend}
            resendSeconds={resendSeconds}
            onResendOtp={onResendOtp}
            onSubmitOtp={onSubmitOtp}
            onGetAvatarImage={onGetAvatarImage}
          />
        );
    }
  };

  return (
    <section className="splits-landing">
      <Box className="splits-landing-container">
        <Box className="splits-landing-logo">
          {canGoBack && (
            <ArrowBackIosNewIcon
              className="back-icon"
              onClick={handleBack}
            />
          )}

          <Box className="logo-container">
            <PaymentLinkLogo />
          </Box>
        </Box>

        {renderStepCard()}

        <SplitsLandingPromoCard onOpenAccount={onOpenAccount} />
      </Box>
    </section>
  );
}

const SplitsPage = () => (
  <SplitsViewModelProvider>
    <SplitsLandingContent />
  </SplitsViewModelProvider>
);

export default SplitsPage;
